const TrackingCodes = Object.freeze({
    // VC Analytics event names
    eventTypes: {
        vcSteps: 'vcSteps',
        vcClick: 'vcClick',
        socialShare: 'socialShare',
        genericClick: 'genericClick',
    },
    // VC Analytics tracking variables
    trackingVars: {
        vcSteps: {
            componentId: 'componentId',
            toolName: 'toolName',
            vcStep: 'vcStep',
        },
        vcClick: {
            componentId: 'componentId',
            toolName: 'toolName',
            vcStep: 'vcStep',
            vcClick: 'vcClick',
        },
        socialShare: {
            componentId: 'componentId',
            urlShared: 'urlShared',
            contentInteraction: 'contentInteraction',
            contentAction: 'contentAction',
            socialNetwork: 'socialNetwork',
        },
        genericClick: {
            componentId: 'componentId',
            destination: 'destination',
            locationInPage: 'locationInPage',
            buttonText: 'buttonText',
        },
    },
    persistentProperties: [
        'adobeAccount',
        'googleAccount',
        'targetCode',
        'pageName',
        'pageType',
        'loginStatus',
        'vehicleModel',
        'vehicleId',
        'vehicleCategory',
        'countryCode',
        'languageCode',
        'mboxActivated',
    ],
    // VC Analytics tracking constant values
    trackingValues: {
        componentIds: {
            virtual_car: 'c314_virtual_car',
        },
        scenes: {
            splash: 'introduction',
            exterior: 'home',
            awaken: 'serenely',
            engine: 'powerfully',
            propilot: 'effortlessly',
            menuOverlay: 'menu:overlay',
            registerInterest: 'register interest',
            trip: 'smartly:app',
            voiceassistant: 'smartly:home',
            inside: 'smartly:in car',
        },
        serenely: {
            scene: 'serenely',
            awaken: 'awaken',
        },
        smartly: {
            navigate: 'navigation',
            music: 'playlist',
            home: 'home',
            message: 'messages',
        },
        powerfully: {
            scene: 'powerfully',
            traffic: 'stop and go traffic',
            activateRain: 'activate rain',
        },
        effortlessly: {
            scene: 'effortlessly',
            activateProPilot2: 'activate pro-pilot 2.0',
            parkTheCar: 'park the car',
            activateProPilotPark: 'activate pro-pilot park',
            getIntoTheCar: 'get into the car',
            moveTheCar: 'move the car',
            proceed: 'proceed',
        },
        socialShare: {
            contentAction: 'intention',
        },
        routes: {
            menuNavigation: 'menu:navigation',
        },
        locationInPage: {
            registerInterest: 'virtual car:register interest',
        },
        toolName: 'virtual car',
        hotspotPrefix: 'hotspot:',
        slidePrefix: 'slide:',
        scrollPrefix: 'scroll:',
    },
});

export default TrackingCodes;
